import * as Sentry from '@sentry/browser';

export default function notifyError(err: Error) {
  Sentry.captureException(err);
}
